import React from "react";
import logger from "./../../../logger";
import axios from "axios";

import { makeStyles } from "@material-ui/core/styles";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpansionPanelActions from "@material-ui/core/ExpansionPanelActions";
import Divider from "@material-ui/core/Divider";

import toastMaker from "./../../../Common/toastmaker";
import LoadingProgress from "./../../../Common/LoadingProgress";
import { getToken, getUser, saveUser } from "./../../../Utils/Common";
import Constants from "./../../../Utils/Constants";

import AddACConfigButton from "./AddACConfigButton";
import ActionButtonWithMenu from "./ActionButtonWithMenu";
import store from "./../../../Common/storage.js";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: "33.33%",
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
}));

const getHeaders = () => {
  return {
    headers: { Authorization: `Bearer ${getToken()}` },
  };
};

export default function ControlledExpansionPanels() {
  const user = getUser();
// console.log(user.configs[store.get("c_id_index")].cxapptoken, 'user')
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);
  const [cxapptokens, setCxapptokens] = React.useState([user.configs[store.get("c_id_index")].cxapptoken]);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const addCXAppToken = () => {
    // logger.log("addActiveCampaignConfig");
    if (cxapptokens && cxapptokens.length >= 5) {
      toastMaker.makeToast("You can only add 5 cxapptokens!", {
        variant: "error",
      });
      return;
    }
    // setIsLoading(true);
    // return axios
    //   .post(Constants.addCXAppTokensApiPath, null, getHeaders())
    //   .then((res) => {
    //     const response = res.data;
    //     logger.log("data", response);
    //     const user = getUser();
    //     user.cxapptokens = response.data.tokens;
    //     saveUser(user);
    //     setCxapptokens(response.data.tokens);
    //     setIsLoading(false);
    //     toastMaker.makeToast("Added new CX App Token!", {
    //       variant: "success",
    //     });
    //   })
    //   .catch((error) => {
    //     setIsLoading(false);
    //     toastMaker.makeToast("Some issue..", {
    //       variant: "error",
    //     });
    //   });
  };

  const onDeleteTemplateSubmit = (row) => {
    setIsLoading(true);
    return axios
      .delete(Constants.deleteCXAppTokensApiPath + "/" + row.id, getHeaders())
      .then((res) => {
        const response = res.data;
        const user = getUser();
        user.cxapptokens = response.data.tokens;
        saveUser(user);
        setCxapptokens(response.data.tokens);
        setIsLoading(false);
        toastMaker.makeToast("Deleted CX App Token..", {
          variant: "success",
        });
      })
      .catch((error) => {
        setIsLoading(false);
        toastMaker.makeToast("Some issue..", {
          variant: "error",
        });
      });
  };

  if (isLoading) {
    return <LoadingProgress />;
  }

  return (
    <ExpansionPanel
      expanded={expanded === "panel1"}
      onChange={handleChange("panel1")}
    >
      <ExpansionPanelSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1bh-content"
        id="panel1bh-header"
      >
        <Typography className={classes.heading}>
          <span className="mb-10"><b>CX App Api Keys</b></span>
        </Typography>
        <Typography className={classes.secondaryHeading}>
          Manage Api Keys for CX Apps
        </Typography>
      </ExpansionPanelSummary>
      <ExpansionPanelDetails style={{ display: "block" }}>
        {cxapptokens &&
          cxapptokens.map((config) => {
            return (
              <tr>
                <td style={{ width: "100%" }}>
                  <div style={{ padding: "10px" }}>
                    <Typography style={{ fontWeight: "bold", wordBreak: "break-all" }}>
                      {config.token}
                    </Typography>
                    <Typography style={{ color: "grey", wordBreak: "break-all" }}>
                      {new Date(config.created_at).toLocaleString()}
                    </Typography>
                  </div>
                </td>
                <td>
                  <div className="o-icon">
                    {/* <ActionButtonWithMenu
                      row={config}
                      onDeleteTemplateSubmit={onDeleteTemplateSubmit}
                    /> */}
                  </div>
                </td>
              </tr>
            );
          })}
      </ExpansionPanelDetails>
      {(!cxapptokens || (cxapptokens && cxapptokens.length < 5)) && (
        <div>
          {/* <Divider /> */}
          <ExpansionPanelActions>
            {/* <AddACConfigButton addCXAppToken={addCXAppToken} /> */}
          </ExpansionPanelActions>
        </div>
      )}
    </ExpansionPanel>
  );
}
